const createFileList = (fileList: File[]) => {
  const dataTransfer = new DataTransfer();

  fileList.forEach((file) => {
    if (file) {
      dataTransfer.items.add(file);
    }
  });

  return dataTransfer.files;
};

const generateUniqueFiles = (fileList: File[]) => {
  return fileList.reduce((files, file) => {
    const isFileExist = files.findIndex((existingFile) => existingFile.name === file.name) !== -1;

    if (!isFileExist) {
      files.push(file);
    }

    return files;
  }, [] as File[]);
};

export { createFileList, generateUniqueFiles };
